import Handlebars from "utilities/vendor/handlebars/4.7.7/js/handlebars";
import hbs from "utilities/vendor/handlebars/4.7.7/js/handlebars";






'use strict';


const helpers = {
  select(data) {
    const requiredAttrs = ['id'];
    const reservedAttrs = ['type', 'data-mask', 'data-gis-mask'];
    const combinableAttrs = {
      class: 'spa-input-select',
      value: '',
      onchange: "this.setAttribute('data-val', this.value);",
      'data-val': '',
    };
    const validationRules = data.validationRules;
    let attrsStr;
    let optionsString = '';

    const helpToggle = data.helpToggle ? data.helpToggle : data.label.text;

    if (!Handlebars.helpers.requiredAttrsCheck(data.select.attrs, requiredAttrs).pass) {

      throw new Error("You are missing the required attribute " + Handlebars.helpers.requiredAttrsCheck(data.select.attrs, requiredAttrs).missingField);


      if (window.console && console.log) {
        console.log("You are missing the required attribute " + Handlebars.helpers.requiredAttrsCheck(data.select.attrs, requiredAttrs).missingField);
        return "";
      }
    }

    Handlebars.helpers.removeReservedAttrs(data.select.attrs, reservedAttrs);
    Handlebars.helpers.combineAttrs(data.select.attrs, combinableAttrs);
    attrsStr = Handlebars.helpers.buildAttrsString(data.select.attrs);

    if (!(data.select.attrs.noEmptyOption)) {
      optionsString = '<option value="">&#160;</option>';
    }

    for (var i = 0, len = data.select.options.length; i < len; i++) {
      var option = data.select.options[i];
      optionsString += '<option value="' + option.value + '" ' + ((option.disabled) ? "disabled" : "") + ' ' + ((option.selected) ? "selected" : "") + ' ' + ((option.hidden) ? "hidden" : "") + '>' + option.text + '</option>';
    }

    var sSelectContainer = "<div class='spa-input spa-input-box spa-dropdown spa-input--" +
      ((data.skin) ? data.skin : "sparta2") +
      ((data.containerClasses) ? " " + data.containerClasses.join(" ") : "") +
      ((data.select.attrs["data-help-body"]) ? (data.select.attrs['data-help-link'] ? " has-help-link" : " has-help") : "") +
      "'>";

    const inputLabelRequiredSpan = (required, asterisk) => {
      if (required && asterisk === false) {
        return "<span class='spa-input-label--required'></span>";
      } else if (required) {
        return "<span class='spa-input-label--required'> *</span>";
      }
      return "";
    };

    var sSelectLabel = "<label class='spa-input-label' data-font='cnx-medium' for='" + data.select.attrs.id + "'>" +
      data.label.text +
      (inputLabelRequiredSpan(data.required, data.asterisk)) +
      "<span class='ada-hidden'>" +
      ((data.label.adaText) ? data.label.adaText : "") +
      "</span>" +
      "</label>"

    let ariaDescribedBy = 'aria-describedby="';
    let isDescribedByAriaTag = false;

    if (data.select.attrs["data-help-body"]) {
      ariaDescribedBy += `helpLayer_${data.select.attrs.id}`;
      isDescribedByAriaTag = true;
    }
    if (data.hintText) {
      if (isDescribedByAriaTag) {
        ariaDescribedBy += ` helpFor_${data.select.attrs.id}`
      } else {
        ariaDescribedBy += `helpFor_${data.select.attrs.id}`
      }
      isDescribedByAriaTag = true;
    }
    ariaDescribedBy += '"';

    var sSelectField = "<select" + attrsStr +
      ((validationRules) ? (" data-validation-rules='" + JSON.stringify(validationRules).replace(/'/g, "&#39;") + "'") : "") +
      ((data.required) ? " required aria-required='true'" + ((typeof data.required === 'string') ? ' data-required-error-message="' + data.required + '"' : '') : "") +
      ((data.disabled) ? " disabled aria-disabled='true'" : "") +
      ((isDescribedByAriaTag) ? ariaDescribedBy : "") +
      ">" +
      optionsString +
      "</select>";

    var sSelectHint = `<p class='spa-input-hint' id="helpFor_${data.select.attrs.id}">` +
      ((data.hintText) ? data.hintText : "") +
      "</p>";

    var sSelectError = "<div class='spa-input-error-message spa-icon--error'" +
      " id='" + data.select.attrs.id + "_errorMessage'" +
      " aria-hidden='true'></div>";

    if (data.select.attrs['data-help-body']) {

      const triggerText = data.select.attrs['data-help-link'] || '';
      const triggerClass = triggerText ? 'toggle-trigger-link' : 'toggle-trigger svg-button';
      let sSelectHelpTrigger = `<a href="javascript: void(0);" id="help-open-${data.select.attrs.id}" role="button" aria-label="${helpToggle}" class="${triggerClass}">${triggerText || '&#160;'}</a>`;
      if (!triggerText) {
        sSelectHelpTrigger = `<span class="toggle-trigger-box">${sSelectHelpTrigger}</span>`;
      }

      var sSelectHelpContainer = "<div class='input-help' id='helpLayer_" + data.select.attrs.id +
        "' role='tooltip' aria-hidden='true' >";

      var sSelectHelpClose = "<a href='javascript:void(0)' id='help-close-" + data.select.attrs.id +
        "' role='button' aria-label='" + helpToggle + "' class='close-trigger svg-button'>&#160;</a>";

      var sSelectHelpBody = "<div class='body'>" + data.select.attrs["data-help-body"] + "</div>";

      if (data.select.attrs["data-help-head"]) {
        sSelectHelpBody = "<div class='head' data-font='cnx-bold'>" +
          data.select.attrs["data-help-head"] +
          "</div>" +
          sSelectHelpBody;
      }

      sSelectHelpContainer += sSelectHelpClose + sSelectHelpBody + "</div>";
      sSelectContainer += sSelectLabel + sSelectField + sSelectHelpTrigger + sSelectHint + sSelectHelpContainer + sSelectError + "</div>";
    } else {
      sSelectContainer += sSelectLabel + sSelectField + sSelectHint + sSelectError + "</div>";
    }

    return new Handlebars.SafeString(sSelectContainer);
  }
};


module.exports.register = function (Handlebars, options) {
  options = options || {};
  for (var helper in helpers) {
    if (helpers.hasOwnProperty(helper)) {
      Handlebars.registerHelper(helper, helpers[helper]);
    }
  }
};

module.exports.helpers = helpers;
